import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import EditWebEmailLinkUI from './editwebemaillinkui';


export default class EditWebEmailLink extends Plugin {
  static get pluginName() {
    return 'EditWebEmailLink';
  }

  static get requires() {
    return [ EditWebEmailLinkUI ];
  }
}
